import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n } from "react/jsx-runtime";
var r = {
	12: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 12 12",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.99986 0.712494C8.92001 0.712494 11.2871 3.07971 11.2872 5.99985C11.2872 8.92005 8.92006 11.2872 5.99986 11.2872C3.07972 11.2871 0.712502 8.92 0.712502 5.99985C0.712581 3.07976 3.07977 0.712573 5.99986 0.712494ZM8.55308 4.23325C8.323 4.02452 7.96714 4.042 7.7584 4.27206L5.36704 6.90732L4.2999 5.82919C4.08134 5.60842 3.72526 5.60697 3.50449 5.82553C3.28374 6.0441 3.28154 6.40018 3.5001 6.62094L4.98545 8.12094C5.09403 8.23051 5.24285 8.29051 5.39707 8.2872C5.55145 8.28384 5.69761 8.21699 5.80137 8.10263L8.5919 5.02792C8.80047 4.79785 8.78309 4.44194 8.55308 4.23325Z",
				fill: "#36863A"
			})
		}),
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.99981 0.950012C11.8933 0.950012 15.0495 4.1063 15.0496 7.99982C15.0496 11.8934 11.8934 15.0496 7.99981 15.0496C4.10629 15.0495 0.950001 11.8934 0.950001 7.99982C0.950106 4.10636 4.10635 0.950118 7.99981 0.950012ZM11.4041 5.64435C11.0973 5.36605 10.6229 5.38935 10.3445 5.69611L7.15606 9.20978L5.7332 7.77228C5.44179 7.47792 4.96702 7.47598 4.67266 7.7674C4.37832 8.05882 4.37539 8.53359 4.6668 8.82794L6.64727 10.8279C6.79204 10.974 6.99046 11.054 7.19609 11.0496C7.40193 11.0451 7.59681 10.956 7.73516 10.8035L11.4559 6.70392C11.734 6.39715 11.7108 5.92261 11.4041 5.64435Z",
				fill: "#36863A"
			})
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 20 20",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.99976 1.1875C14.8667 1.1875 18.8119 5.13286 18.812 9.99976C18.812 14.8668 14.8668 18.812 9.99976 18.812C5.13286 18.8119 1.1875 14.8667 1.1875 9.99976C1.18763 5.13294 5.13294 1.18763 9.99976 1.1875ZM14.2551 7.05542C13.8717 6.70755 13.2786 6.73668 12.9307 7.12012L8.94507 11.5122L7.1665 9.71533C6.80223 9.34738 6.20877 9.34496 5.84082 9.70923C5.4729 10.0735 5.46923 10.667 5.8335 11.0349L8.30908 13.5349C8.49005 13.7175 8.73808 13.8175 8.99512 13.812C9.25241 13.8064 9.49601 13.695 9.66895 13.5044L14.3198 8.37988C14.6675 7.99642 14.6385 7.40324 14.2551 7.05542Z",
				fill: "#36863A"
			})
		}),
		width: 20,
		height: 20
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.9997 1.42499C17.84 1.42499 22.5743 6.15942 22.5744 11.9997C22.5744 17.8401 17.8401 22.5744 11.9997 22.5744C6.15943 22.5742 1.425 17.84 1.425 11.9997C1.42516 6.15952 6.15953 1.42515 11.9997 1.42499ZM17.1062 8.46649C16.646 8.04904 15.9343 8.084 15.5168 8.54413L10.7341 13.8146L8.59981 11.6584C8.16268 11.2168 7.45053 11.2139 7.00899 11.6511C6.56749 12.0882 6.56309 12.8004 7.0002 13.2419L9.9709 16.2419C10.1881 16.461 10.4857 16.581 10.7941 16.5744C11.1029 16.5677 11.3952 16.434 11.6027 16.2053L17.1838 10.0558C17.6009 9.59569 17.5662 8.88388 17.1062 8.46649Z",
				fill: "#36863A"
			})
		}),
		width: 24,
		height: 24
	}
}, i = ({ size: t = 16, ...i }) => /* @__PURE__ */ n(e, {
	source: r[t],
	...i
});
//#endregion
export { i as StatusCompletedIcon };
